import type { UseFormReturn } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IWPLeaderboardFormValues } from './WPLeaderboardForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { FormFileUploader } from '~/components/organisms/fields/FileUploader';
import { IapPollSelector } from '~/components/organisms/fields/IapPollSelector';

export type IWPLeaderboardFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IWPLeaderboardFormValues>;
  appId: string;
};

export const WPLeaderboardFormMainSection: React.FC<
  IWPLeaderboardFormMainSectionProps
> = (props) => {
  const { sx, form, appId } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('WPLeaderboardFormMainSection.fields.iapPollId.label')}
        required
      >
        <FormField
          appId={appId}
          name="iapPollId"
          control={form.control}
          as={IapPollSelector}
          forwardError
        />
      </Labeled>
      <Labeled
        label={t('WPLeaderboardFormMainSection.fields.defaultPictureId.label')}
        required
      >
        <FormFileUploader
          name="defaultPictures"
          control={form.control}
          appId={appId}
          maxFiles={1}
          acceptTypes={['picture']}
        />
      </Labeled>
    </FormSection>
  );
};
